<template>
	<div class="small-12 articleTitle flex" v-if="article">
        <small class="small-12" v-if="article.attributes.author.name">
            By {{article.attributes.author.name}}
        </small>
        <h1 class="small-12 large-6">
            {{ article.attributes.title }}
        </h1>
        <p class="small-12 large-7">
            {{ article.attributes.subtitle }}
        </p>
    </div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ArticleTitle',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			article: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>